"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WaterSplittingPlant = void 0;
const Card_1 = require("../Card");
const CardType_1 = require("../CardType");
const Tags_1 = require("../Tags");
const CardName_1 = require("../../CardName");
const constants_1 = require("../../constants");
const PartyHooks_1 = require("../../turmoil/parties/PartyHooks");
const PartyName_1 = require("../../turmoil/parties/PartyName");
const CardRequirements_1 = require("../CardRequirements");
const CardRenderer_1 = require("../render/CardRenderer");
const RedsPolicy_1 = require("../../turmoil/RedsPolicy");
const Units_1 = require("../../Units");
class WaterSplittingPlant extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.ACTIVE,
            name: CardName_1.CardName.WATER_SPLITTING_PLANT,
            tags: [Tags_1.Tags.BUILDING],
            cost: 12,
            requirements: CardRequirements_1.CardRequirements.builder((b) => b.oceans(2)),
            metadata: {
                cardNumber: '177',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.action('Spend 3 Energy to raise oxygen 1 step.', (eb) => {
                        eb.energy(3).startAction.oxygen(1);
                    });
                }),
                description: 'Requires 2 ocean tiles.',
            },
        });
    }
    play() {
        return undefined;
    }
    canAct(player) {
        const hasEnoughEnergy = player.energy >= 3;
        const oxygenMaxed = player.game.getOxygenLevel() === constants_1.MAX_OXYGEN_LEVEL;
        let trGain = oxygenMaxed ? 0 : 1;
        if (player.game.getOxygenLevel() === 7)
            trGain += 1;
        if (player.game.getTemperature() === -2)
            trGain += 1;
        const redsAreRuling = PartyHooks_1.PartyHooks.shouldApplyPolicy(player, PartyName_1.PartyName.REDS);
        Card_1.Card.setRedsActionWarningText(player, trGain, this, redsAreRuling);
        if (!hasEnoughEnergy)
            return false;
        if (oxygenMaxed)
            return true;
        if (redsAreRuling) {
            this.reserveUnits = Units_1.Units.adjustUnits(this.reserveUnits, { megacredits: trGain * constants_1.REDS_RULING_POLICY_COST });
            const actionDetails = this.getActionDetails();
            this.howToAffordReds = RedsPolicy_1.RedsPolicy.canAffordRedsPolicy(player, player.game, actionDetails);
            if (this.howToAffordReds.mustSpendAtMost !== undefined || this.howToAffordReds.bonusMCFromPlay !== undefined) {
                this.reserveUnits = Units_1.Units.maybeAdjustReservedMegacredits(player, this.reserveUnits, this.howToAffordReds);
            }
            return this.howToAffordReds.canAfford;
        }
        return true;
    }
    action(player) {
        if (this.howToAffordReds !== undefined)
            player.howToAffordReds = this.howToAffordReds;
        player.energy -= 3;
        return player.game.increaseOxygenLevel(player, 1);
    }
    getActionDetails() {
        return new RedsPolicy_1.ActionDetails({ oxygenIncrease: 1 });
    }
}
exports.WaterSplittingPlant = WaterSplittingPlant;
//# sourceMappingURL=WaterSplittingPlant.js.map